import { AssignPlugin } from "../../assets/js/Diagram/plugins/plugins/SmartContractPlugins/AssignPlugin";
import { ExpressionPlugin } from "../../assets/js/Diagram/plugins/plugins/SmartContractPlugins/ExpressionPlugin";
import { DeclarePlugin } from "../../assets/js/Diagram/plugins/plugins/SmartContractPlugins/DeclarePlugin";
import { DoWhileLoopPlugin } from "../../assets/js/Diagram/plugins/plugins/SmartContractPlugins/DoWhileLoopPlugin";
import { ForLoopPlugin } from "../../assets/js/Diagram/plugins/plugins/SmartContractPlugins/ForLoopPlugin";
import { GenericConnectingCirclePlugin } from "../../assets/js/Diagram/plugins/plugins/SmartContractPlugins/GenericConnectingCirclePlugin";
import { IfPlugin } from "../../assets/js/Diagram/plugins/plugins/SmartContractPlugins/IfPlugin";
import { WhileLoopPlugin } from "../../assets/js/Diagram/plugins/plugins/SmartContractPlugins/WhileLoopPlugin";
import { FunctionCallPlugin } from "../../assets/js/Diagram/plugins/plugins/SmartContractPlugins/FunctionCallPlugin";
import { EmitEventPlugin } from "../../assets/js/Diagram/plugins/plugins/SmartContractPlugins/EmitEventPlugin";

export const SMART_CONTRACT_PLUGINS = {
    AssignPlugin,
    ExpressionPlugin,
    DeclarePlugin,
    DoWhileLoopPlugin,
    WhileLoopPlugin,
    ForLoopPlugin,
    GenericConnectingCirclePlugin,
    IfPlugin,
    FunctionCallPlugin,
    EmitEventPlugin
};
